<template>
  <div class="standard-page v-flex">
    <iframe
      :src="transactionReportURL"
      referrerpolicy="unsafe-url"
      height="100%"
      width="100%"
      title="magic iframes for kids"
    ></iframe>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('getMerchantReportURL', {
      reportType: 'transaction-report'
    })
    this.$store.dispatch('setPageTitle', { pageTitle: 'Reports' })
  },
  computed: {
    transactionReportURL() {
      return this.$store.getters.transactionReportURL
    }
  }
}
</script>
